// @flow

import * as React from 'react';
import { Avatar } from '@ta/styleguide.avatar';
import { MemberStatsBasic, MemberName, MemberReasonWhy } from '@ta/social.member-common';
import { MemberBio } from '@ta/social.member';
import { Link } from '@ta/common.routing';
import FollowButton from '@ta/social.follow';
import type { MemberInfo, MemberProfile } from '@ta/social.member-types';
import styles from './FolloweeCard.less';

type Props = {
  member: MemberProfile,
  memberInfo?: MemberInfo,
};

const FolloweeCard = ({ member, memberInfo }: Props) => (
  <React.Fragment>
    <Link href={member?.route?.url} className={styles.candidate} key={member.displayName}>
      <div className={styles.name_and_avatar}>
        <div className={styles.avatar_container}>
          <Avatar photo={member.avatar} withBorder />
        </div>
        <MemberName
          profile={member}
          memberInfo={memberInfo}
          displayNameClassName={styles.display_name}
          addProfileLink={false}
        />
      </div>
      <div className={styles.member_stats_container}>
        <MemberStatsBasic profile={member} />
      </div>
      <MemberBio className={styles.bio} truncateLength={100} bio={member.bio} smallText />
      {memberInfo && memberInfo.infoWithMember && (
        <MemberReasonWhy
          className={styles.reason_why}
          type={memberInfo.suggestedFolloweeType}
          reason={memberInfo.infoWithMember.reason}
          singleLine
        />
      )}
    </Link>
    <FollowButton
      // $FlowFixMe: TRVX-14058 Technical debt; this enum isn't a valid enum!
      size="fullwidth small"
      profile={member}
      displayType="button+icon"
      preventClickPropagation
    />
  </React.Fragment>
);

FolloweeCard.defaultProps = {
  memberInfo: undefined,
};

/** The Followee Card component */
export default React.memo<Props>(FolloweeCard);
